import { faDiscord } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from '@mui/material/Button';

export default function ChatWithUsDiscordButton({ isOutlined }) {
  return (
    <a
      href="https://discord.gg/jWWu73H"
      rel="noopener noreferrer nofollow"
      target="_blank"
    >
      <Button color="primary" variant={isOutlined ? 'outlined' : 'contained'}>
        <FontAwesomeIcon
          style={{ width: '22px', height: '22px' }}
          icon={faDiscord}
          className="mr-2"
        />{' '}
        Chat with Us
      </Button>
    </a>
  );
}
